declare namespace $ {

	export class $mol_icon_bomb extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=bomb.view.tree.d.ts.map